import { useGetList } from "react-admin";
import { Grid } from "@mui/material";

import { administrationRequests } from "api/administrationApi";

const SlotInfo = ({ slot }) => {
  const { data: rooms = [] } = useGetList(
    administrationRequests.getRoomsSelect(),
    {
      filter: slot?.roomId ? { ids: [slot.roomId] } : {},
    },
    {
      enabled: !!slot?.roomId, // важно
    },
  );

  const room = rooms?.[0];

  return (
    <Grid
      container
      spacing={2}
      borderBottom={"0.2px solid #c9c9c9f5"}
      marginBottom={"1rem"}
      padding={"1rem"}
    >
      <Grid
        item
        xs={12}
      >
        Дата: {slot?.date}
      </Grid>

      <Grid
        item
        xs={12}
      >
        Час: {slot.time?.slice(0, 5)}
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
        xl={3}
      >
        Зала: {room ? `${room.roomName} - ${room.buildingName}` : "-"}
      </Grid>
    </Grid>
  );
};

export default SlotInfo;
